import React, { useState, useEffect, useRef } from "react";
import LayoutV2 from "containers/LayoutV2";
import "react-dropdown/style.css";
import UserApi from "service/userApi";
import DanhSachCuaHangApi from "service/danhSachCuaHangApi";
import { formatNumber } from "utils/currencyFormat";
import TableContent from "./TableContent";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
const TongQuatCuaHang = () => {
  const [loading, setLoading] = useState(true);
  const [hasPermission, setHasPermission] = useState(null);
  const [ListData, setListData] = useState([]);
  const [TongQuyTienMat, setTongQuyTienMat] = useState(0);
  const headerRef = useRef(null);
  useEffect(() => {
    document.title = "Tổng quát cửa hàng | Phần mềm quản lý cầm đồ - Morman";

    fetchPermission();
  }, []);
  const fetchPermission = async () => {
    try {
      setLoading(true);
      const res = await UserApi.getAllQuyen();
      const roles = res.data.map((item) => item.ModuleCode.toLowerCase());
      setHasPermission(roles.includes("tongquatcuahang1"));
    } catch (err) {
      console.error("Lỗi load quyền:", err);
      setHasPermission(false);
    }
    finally {
      setLoading(false);
    }
  };
  const onLoadTongQuatCuaHang = async () => {
    try {
      setLoading(true);
      const res = await DanhSachCuaHangApi.TongQuatCuaHang();
      const data = res.data || {};
      setListData(data.List || []);
      setTongQuyTienMat(data.TongQuyTienMat || 0);
    } catch (error) {
      console.error("Lỗi load  tổng quát cửa hàng:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (hasPermission) {
      onLoadTongQuatCuaHang();
    }
  }, [hasPermission]);
  if (hasPermission === null || loading) {
    return (
      <LayoutV2>
        <h2 className="text-danger">
          <div className="custom-table-row">
            <div className="loader loader-default is-active"></div>
          </div>
        </h2>
      </LayoutV2>
    );
  }
  if (hasPermission === false) {
    return (
      <LayoutV2>
        <h2 className="text-danger">
          <div className="custom-table-row">
            <div
              className="custom-table-cell text-center red"
              style={{ width: "100%" }}
            >
              Bạn không có quyền truy cập trang này!
            </div>
          </div>
        </h2>
      </LayoutV2>
    );
  }
  return (
    <LayoutV2>
      <div id="form-repeater">
        <div className="sticky-moman-bh">
          <div className="col-12">
            <div className="camdo-home">
              <div className="breadcrumb-new">
                <div className="row">
                  <div className="col-sm-12 col-md-12 title-cd">
                    <div className="media-home align-center-home">
                      <div className="row header">
                        <img
                          src="/app-assets/images/icon-tong-quat-cua-hang-v2.png"
                          alt="logo"
                        />
                        <h1 className="text-info-home">Quản lý đa cửa hàng - Tổng quát cửa hàng</h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card" style={{ marginTop: "10px", width: "100%", minHeight: "505px" ,borderRadius:"10px",padding:"10px"}}>
                <div className="card-content">
                  <div className="card-body text-center">
                    <div className="Left808x200 mt-1 no-sticky-table">
                      <div className="table-responsive table-1" style={{ width: "auto", overflow: "auto" ,borderRadius:"10px"}}>
                        <table className="table" >
                          <thead ref={headerRef}>
                            <tr>
                              <th rowSpan={2}>Tên cửa hàng</th>
                              <th rowSpan={2}>Quỹ tiền
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip>
                                      Quỹ tiền = (Tiền vốn + Cầm đồ + Tín chấp + Trả góp + Nhận vay + Ngoài lề)
                                    </Tooltip>
                                  }
                                  container={headerRef.current}
                                  popperConfig={{
                                    strategy: "absolute",
                                  }}
                                >
                                  <i className="la la-question-circle tool-comment-main"/>
                                </OverlayTrigger>
                                <br />
                                <span className="color-xanh-bold">
                                  {formatNumber(Math.round(TongQuyTienMat))}
                                </span>
                              </th>
                              <th rowSpan={2}>Tiền vốn</th>
                              <th className="" colspan={2}>Cầm đồ</th>
                              <th className="" colspan={2}>Tín chấp</th>
                              <th className="" colspan={2}>Trả góp</th>
                              <th className="" colspan={2}>Huy động vốn</th>
                              <th className="" colspan={2}>Ngoài lề</th>
                              <th className="" colspan={2}>Quỹ ngân hàng</th>
                              <th className="" rowSpan={2}>Rút quỹ</th>
                            </tr>
                            <tr>
                              <th>Thu</th>
                              <th>Chi</th>
                              <th>Thu</th>
                              <th>Chi</th>
                              <th>Thu</th>
                              <th>Chi</th>
                              <th>Tiền vay</th>
                              <th>Trả lãi</th>
                              <th>Thu</th>
                              <th>Chi</th>
                              <th>Thu</th>
                              <th>Chi</th>
                            </tr>
                          </thead>
                          <tbody>
                            <TableContent
                              dataTongQuatCuaHang={ListData}
                            />

                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <style>{`
        .table-responsive thead th {
          position: sticky;
          top: 0;
          z-index: 1000;
          background: #f8f9fa; 
        }
        .title-tr { color: #2b335e; font-weight: bold }
        .table td, .table th {
          padding: 1rem;
          vertical-align: middle;
          border: 1px solid #E3EBF3 !important;
        }
        .color-bg-1 { background-color: #EDEFF8 !important; }
        .color-bg-2 { background-color: #F7F7FB !important; }
        .color-bg-3 { background-color: #E9EBF4 !important; }
      `}</style>
      </div>
    </LayoutV2>
  );
};

export default TongQuatCuaHang;
